import { $api } from '@service/RequestService';
import { DATE_FORMAT } from '@utils/constants';
import { Pagination } from '@utils/models/Pagination';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';

import { summaryConstants, summaryModels } from '..';

export const useSummaryInsightAdmin = (
  {
    enabled,
    ...props
  }: { enabled?: boolean; page?: number; size?: number; date?: string; dateType?: string; employeeIds?: number[] } = {
    page: 1,
    size: 10,
    date: dayjs().endOf('month').format(DATE_FORMAT),
    dateType: 'MONTH'
  }
) =>
  useQuery<Pagination<summaryModels.Insight>>({
    queryKey: [summaryConstants.queryKeys.SUMMARY_INSIGHT_ADMIN, props],
    queryFn: async () => {
      const res = await $api.post('/v1/summary-insight/admin', {
        ...props
      });

      return res?.data?.data;
    },
    staleTime: Infinity,
    enabled
  });
